import { UserRole } from "shared/constants";
import { api } from "./api";
import { RegisterResponse } from "@/happypaws-shared/src/Authentication/models/RegisterResponse";
import { RegisterInput } from "@/happypaws-shared/src/Authentication/models/RegisterInput";
import { LoginInput } from "@/happypaws-shared/src/Authentication/models/LoginInput";
import { LoginResponse } from "@/happypaws-shared/src/Authentication/models/LoginResponse";

export interface AuthResponse {
  accessToken: string;
  id: string;
  email: string;
  role: UserRole;
}

class AuthService {
  async register(data: RegisterInput): Promise<RegisterResponse> {
    const response = await api.post<RegisterResponse>("/auth/signUp", data);

    // Save token and user
    localStorage.setItem("accessToken", response.data.accessToken);
    localStorage.setItem("user", JSON.stringify(response.data));

    return response.data;
  }

  async login(data: LoginInput): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>("/auth/login", data);
    localStorage.setItem("accessToken", response.data.accessToken);
    localStorage.setItem("user", JSON.stringify(response.data));
    return response.data;
  }

  logout() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    window.location.href = "/login";
  }

  getCurrentUser(): RegisterResponse | null {
    const userStr = localStorage.getItem("user");
    return userStr ? (JSON.parse(userStr) as RegisterResponse) : null;
  }

  getToken() {
    return localStorage.getItem("accessToken");
  }

  isAuthenticated() {
    return !!this.getToken();
  }
}

export const authService = new AuthService();
